export default {
  default: {
    forRent: 'For Rent',
    forSale: 'For Sale',
    sold: 'Sold',
  },
}
